import Angular from "angular";
import Controller from "./chart-booking-resources.controller";
import Template from "./chart-booking-resources.html";

export default Angular.module('chart-booking-resources', [])
    .component('chartBookingResources', {
        template: Template,
        controller: Controller,
        bindings: {
            bookings: '<'
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/chart-booking-resources/chart-booking-resources.js